import { render, staticRenderFns } from "./GameHelp.vue?vue&type=template&id=4eca7680&"
import script from "./GameHelp.vue?vue&type=script&lang=js&"
export * from "./GameHelp.vue?vue&type=script&lang=js&"
import style0 from "./GameHelp.vue?vue&type=style&index=0&id=4eca7680&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports